export const MODULES = [
    {
        name: "Dashboard",
        key: "dashboard",
        permissions: [
            { label: "Dashboard View", value: "dashboard.view" }
        ]
    },
    {
        name: "Customer",
        key: "user",
        permissions: [
            { label: "Customer View", value: "user.view" },
            { label: "Customer Create", value: "user.create" },
            { label: "Customer Edit", value: "user.edit" },
            { label: "Customer Delete", value: "user.delete" }
        ]
    },
    {
        name: "Roles",
        key: "roles",
        permissions: [
            { label: "Roles View", value: "role.view" },
            { label: "Roles Create", value: "role.create" },
            { label: "Roles Edit", value: "role.edit" },
            { label: "Roles Delete", value: "role.delete" }
        ]
    },
    {
        name: "Event",
        key: "event",
        permissions: [
            { label: "Event View", value: "event.view" },
            { label: "Event Create", value: "event.create" },
            { label: "Event Edit", value: "event.edit" },
            { label: "Event Delete", value: "event.delete" }
        ]
    },
    {
        name: "Reading Plan",
        key: "reading_plan",
        permissions: [
            { label: "Reader View", value: "reader.view" },
            { label: "Reader Create", value: "reader.create" },
            { label: "Reader Edit", value: "reader.edit" },
            { label: "Reader Delete", value: "reader.delete" }
        ]
    },
    {
        name: "Bookmark",
        key: "bookmark",
        permissions: [
            { label: "Bookmark View", value: "bookmark.view" },
            { label: "Bookmark Create", value: "bookmark.create" },
            { label: "Bookmark Edit", value: "bookmark.edit" },
            { label: "Bookmark Delete", value: "bookmark.delete" }
        ]
    },
    {
        name: "User",
        key: "mobile_user",
        permissions: [
            { label: "User View", value: "mobile.view" },
            { label: "User Create", value: "mobile.create" },
            { label: "User Edit", value: "mobile.edit" },
            { label: "User Delete", value: "mobile.delete" }
        ]
    },
    {
        name: "Settings",
        key: "settings",
        permissions: [
            { label: "Settings View", value: "settings.view" },
            { label: "Settings Edit", value: "settings.edit" }
        ]
    },
];
